/** @jsx jsx */
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Box, Button, Container, Flex, jsx } from 'theme-ui'
import useNotificationAlertBar from '~/hooks/components/use-notification-alert-bar'
import {
  getAlertBarNotification,
  isAlertBarDismissed,
} from '~/redux/selectors/alert-bar'
import CloseIcon from '~/assets/images/icons/close.inline.svg'

const NotificationAlertBar = () => {
  const { loaded, notification, dismissAlertBar, updateAlertBar } =
    useNotificationAlertBar()
  const alertBarNotification = useSelector(getAlertBarNotification)
  const isDismissed = useSelector(isAlertBarDismissed)

  useEffect(() => {
    updateAlertBar(notification)
  }, [notification, updateAlertBar])

  if (!alertBarNotification || isDismissed) return null

  return (
    <Flex
      sx={{
        alignItems: 'center',
        backgroundColor: 'white',
        minHeight: '52px',
        textAlign: [null, 'center'],
      }}
    >
      <Container sx={{ position: 'relative' }}>
        <Box
          variant="text.callout2"
          py={2}
          px="36px"
          sx={{
            opacity: loaded ? '1' : '0',
            '& p': {
              color: 'brandPrimary',
              m: 0,
            },
          }}
          dangerouslySetInnerHTML={{
            __html: alertBarNotification.description.childMarkdownRemark.html,
          }}
        />
        <Button
          variant="reset"
          onClick={() => dismissAlertBar()}
          sx={{
            bottom: '0',
            position: 'absolute',
            right: '0',
            top: '0',
            width: '52px',
          }}
        >
          <CloseIcon
            color="brandPrimary"
            sx={{ height: '16px', width: '16px' }}
          />
        </Button>
      </Container>
    </Flex>
  )
}

export default NotificationAlertBar
